import request from '@/request/request'

// 查询智能柜存取记录
export function listAccessRecords(data) {
    return request({
        url: '/api/equipment-server/cabinet/accessRecord',
        method: 'post',
        data: data
    })
}
